import { useEffect, useState } from "react";
import api, { errMsg } from "../lib/api";
import { toast } from "sonner";
import { History, Package, Tags, ArrowLeftRight, ShoppingCart, UserCog, KeyRound, Trash2 } from "lucide-react";

const iconFor = (action) => {
  if (action.includes("Barang")) return Package;
  if (action.includes("Mutasi")) return ArrowLeftRight;
  if (action.includes("Penjualan")) return ShoppingCart;
  if (action.includes("Akses") || action.includes("User")) return UserCog;
  if (action.includes("Password")) return KeyRound;
  if (action.includes("Hapus")) return Trash2;
  return Tags;
};

const fmt = (iso) => {
  try {
    return new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export default function ActivityLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/activity-logs").then((r) => setLogs(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  return (
    <div className="space-y-5 animate-fadeup">
      <div>
        <h1 className="text-2xl sm:text-3xl font-display font-extrabold flex items-center gap-2"><History className="w-6 h-6" /> Log Aktivitas</h1>
        <p className="text-[#52525B] text-sm">Jejak perubahan stok, harga & akses (khusus Owner)</p>
      </div>

      {logs.length === 0 ? (
        <div className="nb-card p-10 text-center text-[#52525B]">Belum ada aktivitas tercatat.</div>
      ) : (
        <div className="space-y-2" data-testid="activity-log-list">
          {logs.map((l) => {
            const Icon = iconFor(l.action);
            return (
              <div key={l.id} data-testid={`log-${l.id}`} className="nb-card p-3 flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg border-2 border-[#0A0A0A] flex items-center justify-center shrink-0" style={{ background: "var(--primary)" }}>
                  <Icon className="w-4 h-4" strokeWidth={2.4} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm">{l.action}</div>
                  <div className="text-sm text-[#52525B] break-words">{l.detail}</div>
                  <div className="label-tag mt-0.5">{l.actor_name || l.actor_email} • {fmt(l.created_at)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
